import { Button, Modal } from "antd";

type Props = {
    visible: boolean,
    onClose: () => void,
    onStay: () => void,
}

const WhatsappAlertModal: React.FC<Props> = ({ visible, onClose, onStay }) => {
    return (
        <Modal
            visible={visible}
            footer={null}
            closable={true}
            centered
            closeIcon
        >
            <div style={{ padding: "10px 5px" }}>
                <p style={{ fontWeight: 500 }}>
                    Notifications Whatsapp
                </p>

                <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                    <li style={{ marginBottom: "8px", fontSize: "14px" }}>
                        Tu n'as pas encore autorisé tes notifications whatsapp. Es-tu sûr de vouloir continuer ?
                    </li>
                </ul>

                <div style={{ marginTop: "20px", display: "flex", gap: "10px", flexDirection: "row" }}>
                    <Button type="link" onClick={onClose} className="classBtn classBtn-teal">
                        Oui
                    </Button>
                    <Button type="link" onClick={onStay} className="classBtn classBtn-danger">
                        Non
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default WhatsappAlertModal;